import { useState } from 'react';
import { saveFileWithPicker } from '../../utils/saveFile.ts';
import { tableToXlsx } from '../../utils/tableToXlsx.ts';
import { ModalDialog } from '../modalDialog.tsx';
import { OperationsTable } from '../operation-table/operationsTable.tsx';
import { createExportTable } from './createExportTable.ts';
import { getDefaultScrapFilters, HandledScrapsFilters } from './handledScrapFilters.ts';
import { HandledScrapsFilter } from './handledScrapsFilter.tsx';
import { useGetOperations } from './useGetOperations.ts';
import { useScrapTotal } from './useScrapTotal.ts';


interface Props {
    onClose: () => void;
}

export function HandledScrapsDialog({
    onClose,
}: Props) {
    const [filters, setFilters] = useState<HandledScrapsFilters>(getDefaultScrapFilters());


    const queryFilters = filters.queryFilters;
    const queryFiltersSet =
        !!queryFilters.partDisplayName.trim() ||
        !!queryFilters.orderNumber.trim() ||
        !!queryFilters.startDate ||
        !!queryFilters.endDate;

    const operations = useGetOperations(filters, queryFiltersSet);
    const scrapTotals = useScrapTotal(operations);

    async function handleExportXlsx() {
        if (filters == null || operations == null || scrapTotals == null) return;

        const table = createExportTable(filters!, operations!, scrapTotals!);
        const xlsx = await tableToXlsx(table);
        await saveFileWithPicker('handledScraps.xlsx', xlsx, 'xlsx');
    }


    const isTableVisible = queryFiltersSet && operations;

    return (
        <ModalDialog isOpen={true} onCancel={onClose}>
            <HandledScrapsFilter
                filters={filters}
                setFilters={setFilters}
            />

            <h3>Totals</h3>
            <div style={{ display: 'flex', flexDirection: 'column', 'gap': '4px' }}>
                <div>Cases: {scrapTotals?.numCases ?? 0}</div>
                <div>Initial scraps: {scrapTotals?.initialScraps ?? 0}</div>
                <div>Potential scraps: {scrapTotals?.potentialScraps ?? 0}</div>
                <div>Released scraps: {scrapTotals?.releasedScraps ?? 0}</div>
                <div>Confirmed scraps: {scrapTotals?.confirmedScraps ?? 0}</div>
            </div>

            <div className='flex--horz-centered' style={{ justifyContent: 'space-between' }}>
                <h3>Operations</h3>
                {isTableVisible &&
                    <button onClick={handleExportXlsx}>
                        Export
                    </button>
                }
            </div>
            {!queryFiltersSet && <div style={{ marginTop: '12px' }}>No filters set</div>}
            <OperationsTable
                style={{ visibility: isTableVisible ? 'visible' : 'hidden' }}
                narrow={false}
                operations={isTableVisible ? operations : []}
                showBatch={true}
                operationTypeIndicators={false}
                highlightPotentialScraps={false}
                showScrapLabels={false}
                showScrapReasons={true}
                showOrderNumbers={true}
                enableScrapReview={false}
                enableScrapClose={false}
                showScrapCloseValues={true}
                showEditColumn={false}
                hideEditIfReviewedOrClosed={false}
                enableRevert={false}
            />

            <div className='dialog--button-bar'>
                <button onClick={onClose}>Close</button>
                <button onClick={handleExportXlsx}>Export</button>
            </div>
        </ModalDialog>
    )
}
